import React from 'react';
import LanguageSelect from 'components/LanguageSelect/LanguageSelect';
import Button from '../../../../Buttons/Button';
import Icon from 'components/Icon/Icons';
import { useTranslation } from 'react-i18next';

const BoxHeader = ({
  hasDescription,
  toggleMediaBox,
  minimizeBtnRef,
  noContent,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tour-description__media-title">
      {!noContent && (
        <h2 className="tour-description__stop-name-heading">
          {hasDescription
            ? t('publicTour.titleInfo')
            : t('publicTour.titleMedia')}
        </h2>
      )}
      <LanguageSelect id="box-header" />
      <Button
        className="minimize-media-btn"
        handleClick={toggleMediaBox}
        name="minimize"
        myRef={minimizeBtnRef}
        aria-label={t('publicTour.ada.tourContent.minimize')}
        data-cy="tour-stop-media-box__minimize-btn"
      >
        <Icon>remove_circle</Icon>
      </Button>
    </div>
  );
};

export default BoxHeader;
